import CallPatternAnalysis from "../views/ai-evaluation/call-pattern-analysis/CallPatternAnalysis";

export const RoutePath = {
  aiEvaluationDetail: "evaluation-detail",
  aiEvaluationList: "evaluation-list",
  aiEvaluationDashboard: "evaluation-dashboard",
  conversationalTagsList: "conversational-tags",
  agentPerformanceDashboard: "agent-performance-dashboard",
  agentLevelScoringVsSentiment: "agent-level-scoring-vs-sentiment",
  agentViolations: "agent-violations",
  purposeOfCallDistribution: "purpose-of-call-distribution",
  manageTemplate: "manage-template",
  manageUser: "manage-user",
  knowledgeBase: "knowledge-base",
  callPatternAnalysis: "call-pattern-analysis",
  callPatternAnalysisDetails: "call-pattern-analysis-details",
};

const DynamicBreadcrumbPath = {
  dashboard: "/demo-portal",
  face_recognition: "/demo-portal/solutions/facial-recognition",
  total_scanned: "/demo-portal/solutions/face-recognition/total_scanned",
  validated: "/demo-portal/solutions/face-recognition/validated",
  total_invalidated:
    "/demo-portal/solutions/face-recognition/total_invalidated",
  demo: "/demo-portal/solutions/face-recognition/demo",
  ocr: "/demo-portal/solutions/ocr",
  ocr_scanned: "/demo-portal/solutions/ocr/scanned",
  ocr_pending: "/demo-portal/solutions/ocr/pending",
  ocr_total_failed: "/demo-portal/solutions/ocr/total_failed",
  ai_agent_scoring: "/demo-portal/solutions/ai-agent-scoring",
  ai_pending: "/demo-portal/solutions/ai-agent-scoring/pending",
  ai_reviewed: "/demo-portal/solutions/ai-agent-scoring/ai_reviewed",
  ai_accepted: "/demo-portal/solutions/ai-agent-scoring/ai_accepted",
  ai_rejected: "/demo-portal/solutions/ai-agent-scoring/ai_rejected",
  speech_transcription: "/demo-portal/capabilities/speech-recognition",
  speech_past_history:
    "/demo-portal/capabilities/speech-recognition/past_history",
  summarization_past_history:
    "/demo-portal/capabilities/summarization/past_history",
  summarization: "/demo-portal/capabilities/summarization",
  chatbot: "/demo-portal/capabilities/chatbot",
  chatWithUs: "/demo-portal/capabilities/chatbot/chatWithUs",
  evaluation_dashboard: `/demo-portal/solutions/call-evaluation/${RoutePath.aiEvaluationDashboard}`,
  conversational_tags: `/demo-portal/solutions/call-evaluation/${RoutePath.conversationalTagsList}`,
  evaluation_list: `/demo-portal/solutions/call-evaluation/${RoutePath.aiEvaluationList}`,
  manage_template :`/demo-portal/solutions/call-evaluation/${RoutePath.manageTemplate}`,
  agent_performance_dashboard: `/demo-portal/solutions/call-evaluation/${RoutePath.agentPerformanceDashboard}`,
  agent_level_scoring_vs_sentiment: `/demo-portal/solutions/call-evaluation/${RoutePath.agentLevelScoringVsSentiment}`,
  get_violation: `/demo-portal/solutions/call-evaluation/${RoutePath.agentViolations}`,
  purpose_of_call_distribution: `/demo-portal/solutions/call-evaluation/${RoutePath.purposeOfCallDistribution}`,
  call_pattern_analysis: `/demo-portal/solutions/call-evaluation/${RoutePath.callPatternAnalysis}`,
  call_pattern_analysis_details: `/demo-portal/solutions/call-evaluation/${RoutePath.callPatternAnalysisDetails}`,
};
export default DynamicBreadcrumbPath;
